import { EarlyStageContext } from 'marketing-site/lib/page-behaviors/EarlyStage'
import useModalOpenState from 'marketing-site/lib/useModalOpenState'
import { useRouter } from 'next/router'
import React, { useContext, useEffect } from 'react'
import { RouterWithQueryParams } from '../../utils'
import { AddOnPricingModal } from '../AddonPricingModal'
import { IProps } from './index'

export function HeroForEarlyStage({ renderHero, earlyStageModal }: IProps) {
  const { isEarlyStagePartner, earlyStagePartnerName } = useContext(EarlyStageContext)
  const [modalOpen, openModal, closeModal] = useModalOpenState()

  const modalName = earlyStageModal && earlyStageModal.key

  const router = new RouterWithQueryParams(useRouter())
  const { modal } = router.queryParams()

  useEffect(() => {
    if (modal === modalName) {
      openModal()
    }
  }, [modal, modalName, openModal])

  const closeModalHandler = function (): void {
    const path = router.getCurrentPath()
    const queryParamString = router.removeQueryParam('modal')

    router.updateUrl(`${path}?${queryParamString}`)
    closeModal()
  }

  return (
    <>
      {renderHero(isEarlyStagePartner, earlyStagePartnerName)}
      {earlyStageModal && (
        <AddOnPricingModal
          {...earlyStageModal}
          modalOpen={modalOpen}
          closeModal={closeModalHandler}
        />
      )}
    </>
  )
}
